import React, {Component} from 'react';
import {PGService} from '../../Remote/PowerGym';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import {Paper, withStyles, Grid, TextField, Button} from '@material-ui/core';
import {Face, Fingerprint} from '@material-ui/icons'
import {showSnackbar} from "../../Redux/actions/snackbar";
import {hideLoadingBar, showLoadingBar} from "../../Redux/actions/loading";
import {connect} from 'react-redux';
import './LoginPage.css';
import { withNamespaces } from 'react-i18next';

const styles = theme => ({
    margin: {
        margin: theme.spacing.unit * 2,
    },
    padding: {
        padding: theme.spacing.unit
    }
});

class LoginPage extends Component {

    constructor(props) {
        super(props);

        PGService.logout();

        this.state = {
            username: '',
            password: '',
            submitted: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const {name, value} = e.target;
        this.setState({[name]: value});
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        this.setState({submitted: true});
        const {username, password} = this.state;

        // stop here if form is invalid
        if (!(username && password)) {
            this.props.showSnackbar('Ingrese usuario y contraseña...');
            return;
        }

        const res = await PGService.login(username, password);
        
        if (!res.success) {
            this.props.showSnackbar(res.message || 'Se produjo un error, vuelva a intentarlo más tarde...');
            return;
        }
        
        const { from } = this.props.location.state || { from: { pathname: "/" } };
        this.props.history.push(from);
    }

    handleClickShowPassword = () => {
        this.setState(state => ({showPassword: !state.showPassword}));
    };

    render() {
        const {classes} = this.props;
        const {username, password, submitted} = this.state;
        const instance = this.props.instance.data;
        const {t} = this.props;

        return (
            <form name="form" className='loginForm' onSubmit={this.handleSubmit}>
                <img src={instance.image} alt="" className="instanceImage"/>
                <Paper className={classes.padding}>
                    <div className={classes.margin}>
                        <Grid container spacing={8} alignItems="flex-end">
                            <Grid item>
                                <Face/>
                            </Grid>
                            <Grid item md={true} sm={true} xs={true}>
                                <TextField label={instance.id_label || "DNI"}
                                           name="username"
                                           type="number"
                                           onChange={this.handleChange}
                                           fullWidth
                                           error={submitted && !username}
                                           autoFocus
                                           required/>
                            </Grid>
                        </Grid>
                        <Grid container spacing={8} alignItems="flex-end">
                            <Grid item>
                                <Fingerprint/>
                            </Grid>
                            <Grid item md={true} sm={true} xs={true}>
                                <TextField id="password"
                                           label={t("Password")}
                                           name="password"
                                           type={this.state.showPassword ? 'text' : 'password'}
                                           fullWidth
                                           error={submitted && !password}
                                           required
                                           onChange={this.handleChange}
                                           InputProps={{
                                               endAdornment: (
                                                   <InputAdornment position="end">
                                                       <IconButton
                                                           aria-label={t("Toggle password visibility")}
                                                           onClick={this.handleClickShowPassword}
                                                       >
                                                           {this.state.showPassword ? <VisibilityOff/> : <Visibility/>}
                                                       </IconButton>
                                                   </InputAdornment>
                                               ),
                                           }}/>
                            </Grid>
                        </Grid>
                        <Grid container alignItems="center" justify="space-between">
                            <Grid item>
                            </Grid>
                            <Grid item>
                                {/*<Button disableFocusRipple disableRipple style={{textTransform: "none"}} variant="text"*/}
                                        {/*color="primary">Forgot password ?</Button>*/}
                            </Grid>
                        </Grid>
                        <Grid container justify="center" style={{marginTop: '10px'}}>
                            <Button variant="outlined"
                                    color="primary"
                                    type="submit"
                                    style={{textTransform: "none"}}
                                    disabled={this.props.loading}>{t("Login")}</Button>
                        </Grid>
                    </div>

                </Paper>
            </form>
        );
    }
}
const LoginT = withNamespaces()(LoginPage);

const LoginStyle = withStyles(styles)(LoginT);

const mapStateToProps = (state) => ({
    loading: state.loading,
    instance: state.instance
});

const mapDispatchToProps = dispatch => ({
    showLoadingBar: () => dispatch(showLoadingBar()),
    hideLoadingBar: () => dispatch(hideLoadingBar()),
    showSnackbar: (message) => dispatch(showSnackbar(message))
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginStyle);
